var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"searchable":true,"options":_vm.options,"label":"label","track-by":"value","placeholder":"Select Watcher","multiple":true,"group-select":true,"group-values":"watchers","group-label":"select_all"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }